module.exports = __webpack_public_path__ + "img/share.18dad955.svg";